import { React, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import '../../layouts/stylesheets/first-tracker-source-style.css'
import { sources } from '../Sources.jsx'
import { AiTwotoneSnippets } from 'react-icons/ai'

const Source = (props) => {
  const [formErrors, setFormErrors] = useState({})
  const [selectedIntegration, setSelectedIntegration] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const handleNav = (props) => {
      props.setNav('')
      if (props.nav === 'forward') {
        if (selectedIntegration === '') {
          setFormErrors({ ...formErrors, name: 'Please select a source.' })
          return
        } else {
          props.setCampaignData({
            ...props.campaignData,
            platform: selectedIntegration,
          })
        }
        props.setActivePage('campaignType')
      } else if (props.nav === 'back') {
        if (props.pageType === 'firstTracker') {
          props.setActivePage('postbackJS')
        } else {
          navigate('/trackers')
        }
      }
    }
    handleNav(props)
  }, [formErrors, navigate, props, selectedIntegration])

  const handleSelect = (event) => {
    setSelectedIntegration(event.target.id)
  }

  return (
    <div className="mb-6 w-full max-w-5xl mx-auto h-auto px-4 overflow-x-clip">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 h-full">
        <div className="flex items-center col-span-full">
          <p className="w-full flex items-center gap-2 uppercase mx-auto font-unbounded">
            <AiTwotoneSnippets />
            Select your campaign platform
          </p>
        </div>

        <h3 className="col-span-full w-full text-2xl text-onTrack-nightRider font-unbounded">
          Set up your M-Link
        </h3>

        <p className="col-span-full w-full text-xl mb-8 ">
          {
            'Choose where your campaign is running so we can match data with landing page visits for accurate tracking and reporting.'
          }
        </p>

        {sources.map((s) => (
          <div key={s.id} className="w-full">
            <input
              id={s.id}
              name="source"
              type="radio"
              className="hidden"
              onClick={handleSelect}
            />
            <label
              htmlFor={s.id}
              className="radio-label h-14 relative flex justify-center items-center text-black text-center rounded-3xl text-lg font-light w-full px-4 pl-14 cursor-pointer"
            >
              <img className="h-8 absolute left-4" src={s.image} alt={s.id} />
              <div className="w-fit text-center font-unbounded">{s.name}</div>
            </label>
          </div>
        ))}

        {/* Dummy spacers only for large screens to keep the grid balanced; hidden on small screens */}
        <label
          htmlFor="dummy1"
          className="hidden lg:flex h-14 justify-center items-center bg-gray-50 text-black text-center rounded text-lg w-full p-2.5"
        ></label>
        <label
          htmlFor="dummy2"
          className="hidden lg:flex h-14 justify-center items-center bg-gray-50 text-black text-center rounded text-lg w-full p-2.5"
        ></label>
      </div>

      {formErrors.name ? (
        <p
          className="mx-auto w-fit text-left font-bold p-2.5"
          style={{ color: '#f44' }}
        >
          {formErrors.name}
        </p>
      ) : (
        ''
      )}
    </div>
  )
}

export default Source
